import { defineStore } from 'pinia'

export const FiltersStore = defineStore('tv_filters', {
    state: () => {
        return { tv_filters: [] }
    },
    actions: {
        get() {
            return this.tv_filters
        },
        set(value) {
            this.tv_filters = value
        }
    },
})
export const FiltersSelStore = defineStore('tv_filters_selected', {
    state: () => {
        return { tv_filters_selected: [] }
    },
    actions: {
        get() {
            return this.tv_filters_selected
        },
        set(value) {
            this.tv_filters_selected = value
        }
    },
})

export const TicketsStore = defineStore('tv_tickets', {
    state: () => {
        return { tv_tickets: null }
    },
    actions: {
        get() {
            return this.tv_tickets
        },
        set(value) {
            this.tv_tickets = value
        }
    },
})

export const UpdateTimeStore = defineStore('tv_update', {
    state: () => {
        return { tv_update: new Date() }
    },
    actions: {
        get() {
            return this.tv_update
        },
        set(value) {
            this.tv_update = value
        }
    },
})